import React from 'react';

import styled, { css } from 'styled-components';

import settings from '../global/settings';

import ProductItem from './ProductItem';
import Slider from './Slider/Slider';
import * as SliderQuiz from './Slider/SliderQuiz';
const { StSliderQuiz } = SliderQuiz;

const StQuiz = styled.div`
    @media (min-width: ${settings.bp.large.view}) {
        min-height: calc(100vh - 57px);
    }
`;

const StQuizWrap = styled.div`
    @media (min-width: ${settings.bp.large.view}) {
        display: flex;
    }
`;

const StQuizMainImg = styled.div`
    width: 50%;
    position: relative;
    z-index: 2;
    overflow: hidden;
    display: none;

    @media (min-width: ${settings.bp.large.view}) {
        display: block;
    }
`;

const StQuizMainBg = styled.div`
    position: fixed;
    top: 60px;
    left: 0;
    width: 50%;
    background-size: cover;
    background-position: 50% 0;
    height: calc(100vh - 60px);
`;

const StQuizDesc = styled.div`
    width: 100%;
    padding: 5% 80px;
    text-align: center;

    @media (min-width: ${settings.bp.large.view}) {
        width: 50%;
    }

    h2 {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.11;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        margin: 0 0 20px;
    }

    h3 {
        font-size: 13px;
        font-weight: normal;
        line-height: 1.15;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        margin: 0;
        display: none;

        @media (min-width: ${settings.bp.small.view}) {
            display: block;
        }
    }
`;

const StQuizProductRow = styled.div`
    margin: 50px -80px 0;

    @media (min-width: ${settings.bp.large.view}) {
        .swiper-container.swiper-container-horizontal
            > .swiper-pagination-progressbar {
            max-width: 236px;
        }
    }
`;

const StQuizProductRowTitle = styled.div`
    font-size: 20px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin: 40 0 20px;
`;

const StQuizProductRowInner = styled.div``;

const StQuizBtns = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;

    a {
        font-size: 13px;
        font-weight: normal;
        letter-spacing: 0.08em;
        position: relative;
        padding: 0;

        &:before {
            position: absolute;
            content: '';
            left: 0;
        }
    }
`;

const StQuizRetake = styled.div`
    margin-right: 30px;

    a {
        padding-left: 30px;

        &:before {
            top: -15px;
            left -22px;
            width: 44px;
            height: 44px;
            background-size: 44px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAG7AAABuwE67OPiAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAPBQTFRF////AAAAAAAAAAAAAABAADMzICAgHBwcGhozFRUrEiQkGxsoExwmGRkpFx8nFxwoFRslFB4oFB0nFxwlFxspFhsoFhooFR4mFxsmFxomFh4pFh0oFhwoFx0mFx0oFhwnFhsnFhwnFhwoFxwoFxwnFhsoFh0oFhsnFhsnFhwmFhwoFRwnFRwnFxsnFhwnFhwmFhsnFxwnFhwnFhwnFhsmFh0oFhwnFhwnFhwoFRwnFxwnFhwoFhwnFhwnFhwnFhwnFhwnFhwnFhwnFhsmFhwnFhwnFhwnFhwnFhwnFhwnFhwnFhwnFhwnFhwnFhwnFhwnBdyazAAAAE90Uk5TAAECAwQFCAkKDA4TGx8hLTAzNDc4OTo8Q0RFRlJYWVxodYCHiI2OlZaZmpucnqOmsbW4ubq7vL3ByszO0dja3d7l5+jq7O3v9fb3+Pn7/uxgFD8AAAIBSURBVBgZ7cFrI/JgAAbgu9Im2stIhVCPnHPsJApZqGT3//83b8+iWm2P2eeuCwsLv4ob6Y0VhBPdKjYsm0PW/UVhJ4q/MUsWXV4Kqwju37XNOf1LE8Ekjgf01FtDEEaT3npZBJHpcOzt4ebkrPr8Ram/jSD2B/z2VExF4FjaPP1gfxdBZAYcaeUwTdvLIgijQ0c3H0MYiSYdbRPhHNPRTCKcfwNK7STUtAN4u6bUNaGm3VHAi2lTykNNK5MU8FCi1IpBSStTEpgTtSjloKRVOCIwa4vSE5S0Cn8IzChSKkJFr3JCwK1BKQUFvcppAi4Wh94j8KfX6CYwJW5z6BH+9BpnCUwYlG7hS69znsBYmlIJfpbr9CIg6KW+DD8lSmmMCc6r6/B1S8nAhOCsmg5/jxyy45gi6FbT4S/yziELLoLTqjoUUpQacBOcqOpQKVI6xAzBHxUNSk+UUpglOFLRoJSj9BrBHEGprEEp1qJ0Dg+CZFmDWp6SvQ4vgnca1MwupSt4O9CglmxT+jQQTrJJxxHCMdt0NBMII5bv0tExEER2T8O0XIsjgwyC2O3z43RzCY5IqvjEb4N9BLHdp/T1XD07uXl441gngyCyPXprGghirUdPn0cJBGNe9jnHvjIQ3GrhhS6v5+v4m+hO4eLe4pBtNQ5TEYSzspE24lhY+M1/7NvqO8N3vcoAAAAASUVORK5CYII=');
        }
    }
`;

const StQuizDownload = styled.div`
    margin-left: 30px;

    a {
        padding-left: 24px;

        &:before {
            top: 0;
            width: 16px;
            height: 16px;
            background-size: 16px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhsNMjaWyyJxAAAA5UlEQVRo3u3YwQ2CQBCF4afhbgHWYGIZJBSgoQq5UZJ2YytWoEcwrsvM7Mzu5c1eNizh/44AIJ0Bb8UapI/diwFBQwABBBBAAAEEEEAAAd1qf8Alc+dJ9dwex8zpA6/0wU316m1dc04eT8jm4wmb+ViCKB9HEOdjCKq8P0Gd9yWY8n4Ec96HUJQvJxTnywgueTvBLW8juOb1BPe8jhCSlxPC8jJCaH6bEJ7PE6rk/xOq5dOEqvlfQvX8N6FJfiE0ywPAhKllnsPhOMxutT/jWql6xzN1eSz6AtCscYk2/0lFAAHNAR9lKO7q4PpRsQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wMi0yN1QxMzo1MDo1NCswMDowMLzQAzwAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDItMjdUMTM6NTA6NTQrMDA6MDDNjbuAAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==');
        }
    }
`;

const StQuizEmail = styled.div`
    margin-left: 30px;

    a {
        padding-left: 24px;

        &:before {
            top: 0;
            width: 16px;
            height: 16px;
            background-size: 16px;
            background-image: url('data:image/png;base64,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');
        }
    }
`;

const StQuizSliderContainer = styled.div`
    display: flex;
    // padding: 0 30px;

    @media (min-width: ${settings.bp.small.view}) {
        // padding: 0 60px;
    }

    @media (min-width: ${settings.bp.large.view}) {
        // padding: 0 30px;
    }

    &:not(.swiper-slide) {
        margin-left: auto;
        margin-right: auto;
    }

    .StProductListItemImg {
        margin-left: auto;
        margin-right: auto;
        width: 200px;
        height: 200px;

        @media (min-width: ${settings.bp.small.view}) {
            width: 300px;
            height: 300px;
        }

        @media (min-width: ${settings.bp.large.view}) {
            width: calc(25vw - 60px);
            height: calc(25vw - 60px);
        }

        img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
        }
    }
`;

const StQuizProductChoiceSeperator = styled.div`
    font-size: 22px;
    margin: 40% 0px 0px -15px;
`;

const StQuizProductProTips = styled.div`
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    margin: 30px 0px;
`;

function QuizProducts(props) {
    const { title, items, productProTips, showSeperator, seperatorText } = props;
    let showSeperatorText = false;
    if (showSeperator && items && items.length > 1) {
        showSeperatorText = true;
    }

    return (
        <StQuizProductRow>
            {title && <StQuizProductRowTitle>{title}</StQuizProductRowTitle>}
            {items && (
                <StQuizProductRowInner>
                    <Slider
                        settings={{
                            slidesPerView: 2,
                        }}
                        hideProgress={items.length <= 2}
                    >
                        {items.map((item, index) => (
                            <StQuizSliderContainer>
                                <StSliderQuiz key={item.id || index}>
                                    <ProductItem isQuiz={true} {...item} />
                                </StSliderQuiz>
                                {showSeperatorText &&
                                    index < items.length - 1 && (
                                        <StQuizProductChoiceSeperator>
                                            {seperatorText}
                                        </StQuizProductChoiceSeperator>
                                    )}
                            </StQuizSliderContainer>
                        ))}
                    </Slider>
                </StQuizProductRowInner>
            )}
            {productProTips && <StQuizProductProTips>{productProTips}</StQuizProductProTips>}
        </StQuizProductRow>
    );
}

export default function Quiz(props) {
    const {
        mainImage,
        title,
        subtitle,
        products,
        showRetakeBtn,
        onClickRetakeBtn,
        retakeBtnText,
        showDownloadBtn,
        onClickDownloadBtn,
        downloadBtnText,
        showEmailBtn,
        onClickEmailBtn,
        emailBtnText,
        seperatorText,
    } = props;
    return (
        <StQuiz>
            <StQuizWrap>
                {mainImage && (
                    <StQuizMainImg>
                        <StQuizMainBg
                            style={{ backgroundImage: `url("${mainImage}")` }}
                        />
                    </StQuizMainImg>
                )}
                <StQuizDesc>
                    {title && <h2>{title}</h2>}
                    {subtitle && <h3>{subtitle}</h3>}
                    {products &&
                        products.map((item, index) => (
                            <QuizProducts
                                key={item.id || index}
                                {...item}
                                seperatorText={seperatorText}
                            />
                        ))}
                    <StQuizBtns>
                        {showRetakeBtn && (
                            <StQuizRetake>
                                <a onClick={onClickRetakeBtn} href="/">
                                    {retakeBtnText}
                                </a>
                            </StQuizRetake>
                        )}
                        {showDownloadBtn && (
                            <StQuizDownload>
                                <a onClick={onClickDownloadBtn} href="/">
                                    {downloadBtnText}
                                </a>
                            </StQuizDownload>
                        )}
                        {showEmailBtn && (
                            <StQuizEmail>
                                <a onClick={onClickEmailBtn} href="/">
                                    {emailBtnText}
                                </a>
                            </StQuizEmail>
                        )}
                    </StQuizBtns>
                </StQuizDesc>
            </StQuizWrap>
        </StQuiz>
    );
}
